import { differenceRows } from "@/mocks/difference";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function DifferenceSection() {
  return (
    <section id="difference" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="与原著区别"
            title="潘金莲电影与原著，差在哪里"
            desc="原著写的是情节与训诫，影视作品要面对时长、观众和时代。把两者放在一起对照，才能看清改编到底动了哪些地方。"
          />
        </Reveal>

        <Reveal className="mt-10">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="hidden md:grid md:grid-cols-12 bg-secondary-100">
              <div className="col-span-3 px-5 py-3 font-label text-xs tracking-wide text-secondary-900">
                对比维度
              </div>
              <div className="col-span-4 px-5 py-3 font-label text-xs tracking-wide text-secondary-900">
                原著（《水浒传》/《金瓶梅》）
              </div>
              <div className="col-span-5 px-5 py-3 font-label text-xs tracking-wide text-secondary-900">
                影视改编
              </div>
            </div>

            <div className="divide-y divide-background-200">
              {differenceRows.map((row) => (
                <div key={row.dimension} className="grid grid-cols-1 md:grid-cols-12">
                  <div className="md:col-span-3 px-5 pt-4 md:py-5">
                    <span className="inline-flex items-center gap-2 font-heading text-sm font-bold text-primary-700">
                      <i className="ri-more-2-fill text-primary-400"></i>
                      {row.dimension}
                    </span>
                  </div>
                  <div className="md:col-span-4 px-5 py-2 md:py-5">
                    <span className="md:hidden mb-1 block font-label text-[11px] text-foreground-500">
                      原著
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{row.novel}</p>
                  </div>
                  <div className="md:col-span-5 px-5 py-2 pb-5 md:py-5">
                    <span className="md:hidden mb-1 block font-label text-[11px] text-foreground-500">
                      影视改编
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{row.film}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}